import CodeMirror from '@uiw/react-codemirror'
import { sql } from '@codemirror/lang-sql'
import { useTheme } from '@/theme'

interface SqlEditorProps {
  value: string
  onChange: (value: string) => void
  readOnly?: boolean
}

/**
 * SQL Editor Component
 *
 * CodeMirror-based SQL editor with syntax highlighting and theme support.
 *
 * Feature: 055-db-console
 */
export function SqlEditor({ value, onChange, readOnly = false }: SqlEditorProps) {
  const { effectiveTheme } = useTheme()

  return (
    <CodeMirror
      value={value}
      height="300px"
      extensions={[sql()]}
      onChange={onChange}
      theme={effectiveTheme === 'dark' ? 'dark' : 'light'}
      className="border border-border rounded-md overflow-hidden"
      readOnly={readOnly}
      basicSetup={{
        lineNumbers: true,
        highlightActiveLineGutter: true,
        highlightSpecialChars: true,
        foldGutter: true,
        drawSelection: true,
        dropCursor: true,
        allowMultipleSelections: true,
        indentOnInput: true,
        bracketMatching: true,
        closeBrackets: true,
        autocompletion: true,
        rectangularSelection: true,
        crosshairCursor: true,
        highlightActiveLine: true,
        highlightSelectionMatches: true,
        closeBracketsKeymap: true,
        searchKeymap: true,
        foldKeymap: true,
        completionKeymap: true,
        lintKeymap: true,
      }}
    />
  )
}
